/* Styles for the practice page and quiz. Plain CSS in a <style> tag (like the
   other public pages), so the prerendered HTML is styled before any JS runs.
   Mobile first: base rules are for phones, @media blocks widen the layout.
   Colours match the landing page (zinc greys + amber accent). */

export const PRACTICE_CSS = `
.tk-pr { width: min(100% - 2rem, 46rem); margin: 0 auto; padding: 1rem 0 5rem; color: #18181b; }
.tk-pr a { color: #18181b; text-decoration: underline; text-underline-offset: 3px; }
.tk-pr a:hover { color: #52525b; }

.tk-crumbs ol { display: flex; flex-wrap: wrap; gap: .4rem; list-style: none; font-size: .85rem; color: #71717a; }
.tk-crumbs li + li::before { content: "/"; margin-right: .4rem; color: #a1a1aa; }
.tk-crumbs a { color: #52525b; }

.tk-pr-header { margin: 1.5rem 0 2rem; }
.tk-pr h1 { font-size: 2.1rem; line-height: 1.12; font-weight: 800; letter-spacing: -.03em; }
.tk-pr-lead { margin-top: 1rem; font-size: 1.1rem; line-height: 1.65; color: #52525b; }

.tk-pr-section { margin-top: 3.5rem; }
.tk-pr-section h2 { font-size: 1.5rem; line-height: 1.25; font-weight: 800; letter-spacing: -.02em; margin-bottom: 1rem; }
.tk-pr-section p { line-height: 1.75; color: #3f3f46; margin-bottom: 1rem; }
.tk-pr-topics, .tk-pr-tips, .tk-pr-links { padding-left: 1.3rem; line-height: 1.75; color: #3f3f46; }
.tk-pr-topics { list-style: disc; }
.tk-pr-tips { list-style: decimal; }
.tk-pr-links { list-style: disc; }
.tk-pr-topics li, .tk-pr-tips li, .tk-pr-links li { margin-bottom: .5rem; }
.tk-pr-topics strong { color: #18181b; }
.tk-pr-cta { padding: 1.75rem 1.5rem; border-radius: 1.25rem; background: #fffbeb; border: 1px solid #fde68a; }

/* ---- quiz card ---- */
.tk-quiz { padding: 1.5rem 1.25rem; border: 1px solid #e4e4e7; border-radius: 1.25rem; background: #fff;
  box-shadow: 0 18px 40px -24px rgba(0,0,0,.25); outline: none; scroll-margin-top: 1rem; }
.tk-quiz-center { display: flex; flex-direction: column; align-items: center; gap: 1rem; text-align: center; padding: .5rem 0; }
.tk-quiz-title { font-size: 1.5rem; font-weight: 800; letter-spacing: -.02em; }
.tk-quiz-muted { color: #52525b; line-height: 1.6; }
.tk-quiz-meta { display: flex; align-items: center; justify-content: space-between; gap: .75rem; font-size: .85rem; font-weight: 600; color: #71717a; }
.tk-quiz-chip { padding: .2rem .6rem; border-radius: 999px; background: #f4f4f5; color: #3f3f46; font-weight: 600; font-size: .75rem; text-align: right; }
.tk-progress { height: 6px; margin: .75rem 0 1.25rem; border-radius: 999px; background: #f4f4f5; overflow: hidden; }
.tk-progress span { display: block; height: 100%; background: #fbbf24; transition: width .3s ease; }
.tk-quiz-question { font-size: 1.2rem; line-height: 1.4; font-weight: 700; }
.tk-quiz-image { display: block; width: 100%; max-width: 20rem; height: auto; margin: 1rem auto 0; border-radius: .75rem; background: #fafafa; }

.tk-options { display: grid; gap: .6rem; margin: 1.25rem 0; }
.tk-option { display: flex; align-items: flex-start; gap: .75rem; width: 100%; min-height: 3.25rem; padding: .8rem 1rem;
  border: 1.5px solid #e4e4e7; border-radius: .9rem; background: #fff; color: #18181b; font-size: 1rem; line-height: 1.45;
  text-align: left; cursor: pointer; transition: border-color .15s, background-color .15s; }
.tk-option:hover:not(:disabled) { border-color: #a1a1aa; background: #fafafa; }
.tk-option:disabled { cursor: default; }
.tk-option-letter { flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; width: 1.75rem; height: 1.75rem;
  border-radius: .5rem; background: #f4f4f5; font-size: .85rem; font-weight: 700; }
.tk-option.is-correct { border-color: #16a34a; background: #f0fdf4; }
.tk-option.is-correct .tk-option-letter { background: #16a34a; color: #fff; }
.tk-option.is-wrong { border-color: #dc2626; background: #fef2f2; }
.tk-option.is-wrong .tk-option-letter { background: #dc2626; color: #fff; }
.tk-option.is-dim { opacity: .55; }

.tk-feedback { margin-bottom: 1.25rem; padding: 1rem 1.1rem; border-radius: .9rem; line-height: 1.6; }
.tk-feedback.is-correct { background: #f0fdf4; color: #14532d; }
.tk-feedback.is-wrong { background: #fef2f2; color: #7f1d1d; }
.tk-feedback-title { font-weight: 700; margin-bottom: .35rem; }

.tk-score { font-size: 2.25rem; font-weight: 800; letter-spacing: -.02em; }
.tk-quiz-cta { width: 100%; margin: .5rem 0; padding: 1.25rem; border-radius: 1rem; background: #fffbeb; border: 1px solid #fde68a; }
.tk-quiz-cta h3 { font-size: 1.15rem; font-weight: 800; margin-bottom: .4rem; }
.tk-quiz-cta p { color: #3f3f46; line-height: 1.6; }

.tk-btn { display: inline-flex; align-items: center; justify-content: center; min-height: 3rem; padding: .75rem 1.5rem;
  border-radius: 999px; font-size: 1rem; font-weight: 700; cursor: pointer; transition: background-color .15s, transform .1s; }
.tk-btn:active { transform: scale(.98); }
.tk-btn--primary { background: #18181b; color: #fff; border: none; }
.tk-btn--primary:hover { background: #3f3f46; }
.tk-btn--ghost { background: transparent; color: #18181b; border: 1.5px solid #d4d4d8; }
.tk-btn--block { width: 100%; }

.tk-stores { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: .5rem 1rem; margin-top: 1rem; }
.tk-pr-cta .tk-stores { justify-content: flex-start; }
.tk-stores a { text-decoration: none; }
.tk-store-apple { height: 48px; width: auto; }
.tk-store-google { height: 70px; width: auto; margin: -11px; object-fit: contain; }

.tk-quiz :focus-visible, .tk-pr a:focus-visible { outline: 2px solid #18181b; outline-offset: 2px; }

@media (min-width: 640px) {
  .tk-pr { padding-top: 2rem; }
  .tk-pr h1 { font-size: 2.75rem; }
  .tk-quiz { padding: 2rem; }
  .tk-quiz-question { font-size: 1.35rem; }
}
@media (prefers-reduced-motion: reduce) {
  .tk-progress span, .tk-option, .tk-btn { transition: none; }
}
`;
